//@ts-ignore
import Swiper, { Pagination, Navigation } from 'swiper';
Swiper.use([Pagination, Navigation]);


export namespace StackRotator {
	let setupStackRotator = () => {
		let stackRotators = document.querySelectorAll('.js-stack-rotator');

		if(!stackRotators.length) {
			return;
		}

		stackRotators.forEach((slider, index) => {
			let sliderList = [];
			let numberOfSlides = parseInt(slider.getAttribute('data-slides'));
			slider.classList.add(`stack-rotator--${index}`);
			let carouselParent = slider.parentElement;
			let leftArrow = carouselParent.querySelector(".stack-rotator__arrow-left");
			let rightArrow = carouselParent.querySelector(".stack-rotator__arrow-right");
			leftArrow.classList.add(`stack-rotator__arrow-left--${index}`);
			rightArrow.classList.add(`stack-rotator__arrow-right--${index}`);

			//setup each swiper instance
			let swiper:any = new Swiper(`.stack-rotator--${index}`,{
				// Optional parameters
				slidesPerView: numberOfSlides,
				navigation: {
					nextEl: `.stack-rotator__arrow-right--${index}`,
					prevEl: `.stack-rotator__arrow-left--${index}`,
				},
				spaceBetween: 15,
				breakpoints: {
					0: {
						slidesPerView: 1,
					},
					480: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: numberOfSlides,
					},
				},
				on: {
					init: function () {
						let images = slider.querySelectorAll('.stack__img');
						images.forEach((stackImg) => {
							stackImg.classList.remove('state-hidden');
						})
					},
				},
			});

			//push up the swiper data
			sliderList.push(swiper);
			swiper.init();
		});
	}
	export const init = () => {
		setupStackRotator();
	}
}
